'use strict'

/**
 * Constructs an array of metadata objects for a given category, metatags, and optional search query.
 *
 * This function generates metadata for a webpage by prioritizing the category's metadata properties
 * and falling back to the provided metatags or search query if necessary. The metadata includes
 * description, title, keywords, and robots directives.
 *
 * @param {Object} categoryOrProduct - The category or product object containing metadata properties such as pageDescription, pageTitle, and pageKeywords.
 * @param {Array<Object>} metatags - An array of metatag objects, each containing an 'id' and 'value' property.
 * @param {string} [searchQuery=''] - An optional search query string used as a fallback for description and title metadata.
 * @returns {Array<Object>} An array of metadata objects, each with an 'id' and 'value' property, representing the metadata for the webpage.
 */
export const buildMetaData = (categoryOrProduct, metatags, searchQuery = '') => {
    return [
        {
            id: 'description',
            value:
                categoryOrProduct?.pageDescription ||
                metatags?.find((tag) => tag.id === 'description')?.value ||
                searchQuery
        },
        {
            id: 'title',
            value:
                categoryOrProduct?.pageTitle ||
                metatags?.find((tag) => tag.id === 'title')?.value ||
                searchQuery
        },
        {
            id: 'keywords',
            value:
                categoryOrProduct?.pageKeywords ||
                metatags?.find((tag) => tag.id === 'keywords')?.value ||
                ''
        },
        {
            id: 'robots',
            value: metatags?.find((tag) => tag.id === 'robots')?.value || ''
        }
    ]
}
